<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
import { utilityService } from "../../../../../services/managements/utilities/utility.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Utilities",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Utilities",
      breadCrumb: {},

      data: {},
      projectData: {},

      valueId: 0,
      valueName: '',
      valueNameEn: '',
      valuePrice: 0,
      valueProjectId: 0,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    }else{
      this.loadingData(0);     
    }
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      utilityService.getOne(id)
        .then(response => {
          this.fetchingStats = true;
          if(response.data){
            this.data = response.data;

            this.breadCrumb = {
              text: response.data.name,
              active: true,
            };

            this.valueId = this.data.id;
            this.valueName = this.data.name;
            this.valueNameEn = this.data.name_en;
            this.valuePrice = this.data.price;
            this.valueProjectId = this.data.project_id;
          }

          console.log(response.data);

          this.projectData = {data: response.setting.projects}
        });
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      let data = {
        name: this.valueName,
        name_en: this.valueNameEn,
        price: this.valuePrice,
        project_id: this.valueProjectId
      };

      console.log(JSON.stringify(data))

      if(this.isAdd) {
        utilityService.insert(data).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            this.clearForm();
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-setting-utility"
                });
              } 
            });
          }
        });
      } else {
        utilityService.update(this.$route.params.id, data).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-setting-utility"
                });
              } 
            });

          }
        });
      }

    },
    clearForm: function() {
      this.valueName = '';
      this.valueNameEn = '';
      this.valuePrice = 0;
    },


  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('manage.utility.text'),
        href: '/manage/setting/utility',
      }, {
        text: this.isAdd ? $t('manage.utility.new') : $t('manage.utility.edit'),
        active: true
      }]" :title="this.isAdd ? $t('manage.utility.new') : $t('manage.utility.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('manage.utility.text'),
        href: '/manage/setting/utility',
      }, this.breadCrumb]" :title="this.isAdd ? $t('manage.utility.new') : $t('manage.utility.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'manage.utility.name'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :require="true"
                    :label="'manage.name_en'"  />
                </div>
               
               
              </div>
              <div class="row">
                 <div class="col-md-4">
                    <Select
                      :id="'project_id'"
                      :editable="false"
                      v-model="valueProjectId"
                      :list="this.projectData"
                      :label="'property.project'"
                      :require="true"
                    /> 
                </div>
                 <div class="col-md-4">
                  <Input 
                    :type="'number'"
                    :step="'0.01'"
                    :id="'price'"
                    v-model="valuePrice"
                    :require="true"
                    :label="'manage.utility.price'"  />
                </div>
              </div>


              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>